import { FC } from 'react';
import { createRoot } from 'react-dom/client';

import Application from './App';

// AQA needs
window.HIDE_FRONT_CHAT = Number(import.meta.env.HIDE_FRONT_CHAT);

const root = createRoot(document.getElementById('root') as HTMLElement);

const Root: FC = () => {
    return <Application />;
};

root.render(<Root />);
